// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles__tag___efjiC","approved":"styles__approved___1dNlk","rejected":"styles__rejected___2YOT9","pending":"styles__pending___SVwb8"};